import axios from 'axios';
const { VUE_APP_API_KEY } = process.env;

const api = axios.create({
  baseURL: 'https://choice-dassie-68.hasura.app/api/rest',
  headers: { 'x-hasura-admin-secret': VUE_APP_API_KEY },
});

export { api };
